<script lang="ts" setup>
import { type PropType, onUnmounted, useId } from '#imports';
import { MdPreview } from '@kaokei/md-editor-v3';
import '@kaokei/md-editor-v3/lib/preview.css';
import {
  clearMarkdownOptions,
  setMarkdownOptions,
} from '~/utils/markdown/markdown-manager';
import '~/utils/markdown/md-editor-config';
import { useRunCode } from '~/utils/markdown/use-run-code';

const props = defineProps({
  type: {
    type: String as PropType<'post' | 'comment'>,
    default: '',
  },
  showRunButton: {
    type: Boolean,
    default: false,
  },
});

const model = defineModel({ type: String });

const id = useId();

setMarkdownOptions(id, {
  id,
  type: props.type,
  showRunButton: props.showRunButton,
});

useRunCode(id);

onUnmounted(() => {
  clearMarkdownOptions(id);
});
</script>

<template>
  <MdPreview
    :id="id"
    v-model="model"
    preview-theme="github"
    code-theme="github"
    :show-code-row-number="!!props.type"
    :code-foldable="!!props.type"
    :no-highlight="!props.type"
    :auto-fold-threshold="100"
    :data-id="{ name: 123 }"
  ></MdPreview>
</template>

<style scoped>
:deep(.md-editor-preview .md-editor-code .md-editor-code-head) {
  z-index: 0 !important;
}
:deep(.md-editor-preview .ui pre code.lang-plain) {
  display: flex !important;
}
</style>
